import React from 'react';
import { ActionIcon } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { ActionCellContainer } from '@dealstack/frontend/app/pages/Valuations/components/table/cells/styled';
import { useTheme } from 'styled-components';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	rowId: string;
	onDelete: (rowId: string) => void;
	disabled?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed. Please utilise the columnBuilder instead.
 */
export const DeleteActionCell = ({ rowId, onDelete, disabled = false }: Props) => {
	const theme = useTheme();

	const handleDelete = () => {
		onDelete(rowId);
	};

	return (
		<ActionCellContainer>
			<ActionIcon
				data-testid={TEST_ELEMENT_IDS.DELETE_ACTION_CELL}
				size="md"
				onClick={handleDelete}
				disabled={disabled}
			>
				<Icon
					variant="delete"
					size="md"
					disabled={disabled}
					color={disabled ? undefined : theme.color.error[500]}
				/>
			</ActionIcon>
		</ActionCellContainer>
	);
};
